import { render, staticRenderFns } from "./IconMail.vue?vue&type=template&id=cfd4e1a8&"
import script from "./IconMail.vue?vue&type=script&lang=ts&"
export * from "./IconMail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports